import Infoservice from './Index'

export default [
  {
    path: '/infoservice',
    name: 'infoservice',
    component: Infoservice,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
]
